'use strict';

import './previousNext.scss';
import template from './previousNext.template.html';
import controller from './previousNext.controller.js';

const component = {
    bindings: {},
    controller,
    template
};

export default component;
